import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { TimelineItemLayout } from "web_myplann/NotificationCenter/Components/TimelineItemLayout";
import { useTimelineEntryDateLine } from "web_myplann/NotificationCenter/Hooks/useTimelineEntryDateLine";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import { TimelineRowVariant } from "web_myplann/NotificationCenter/Types/TimelineRowVariant";

interface ResolvingNowItemProps {
	item: TimelineItemResponseDTO;
	onClick?: (item: TimelineItemResponseDTO) => void;
	isLast?: boolean;
}

export const ResolvingNowItem: FC<ResolvingNowItemProps> = ({
	item,
	onClick,
	isLast = false,
}) => {
	const dateLine = useTimelineEntryDateLine(item, TimelineDateStyle.Absolute);

	return (
		<TimelineItemLayout
			item={item}
			dateLine={dateLine}
			showChevron={!!onClick}
			disabled={!onClick}
			onClick={onClick ? () => onClick(item) : undefined}
			isLast={isLast}
			variant={TimelineRowVariant.Task}
			data-testid={`resolving-now-item-${item.id}`}
		/>
	);
};
